interface LogoProps {
  size?: number
}

export function Logo({ size = 32 }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="none"
      aria-label="abaddon"
      style={{ color: 'var(--color-fg)' }}
    >
      <ellipse cx="50" cy="50" rx="44" ry="26" stroke="currentColor" strokeWidth={3}/>
      <ellipse cx="50" cy="54" rx="34" ry="19" stroke="currentColor" strokeWidth={2.5} opacity={0.72}/>
      <ellipse cx="50" cy="57" rx="24" ry="13" stroke="currentColor" strokeWidth={2} opacity={0.48}/>
      <ellipse cx="50" cy="60" rx="14" ry="7.5" stroke="currentColor" strokeWidth={1.5} opacity={0.28}/>
      <ellipse cx="50" cy="62" rx="5.5" ry="2.5" stroke="currentColor" strokeWidth={1} opacity={0.14}/>
    </svg>
  )
}
